import Footer from "Components/Footer/Footer";
import Navigation from "Components/Navigation/Navigation";

const About = () => {
  return (
    <div className="page-wrapper">
      <Navigation />
      <h1>About Page </h1>
      <p className="work-in-progress">Still work in progress</p>
      <Footer />
    </div>
  );
};

export default About;
